const endpoint = {
  // SuiteQL Endpoints
  GET_ALL_CLASSIFICATIONS: "/suiteql/classification",
  GET_ALL_BRANDS: "/suiteql/brand",
  GET_ALL_UNIQUE_BRANDS: "/suiteql/brand/unique-brands",
  GET_ALL_UNIQUE_MANUFACTURERS: "/suiteql/manufacturer/unique-manufacturers",
  GET_BRANDS_BY_CLASSIFICATION: (classId) =>
    `/suiteql/brand/unique-brands?classId=${classId}`,
  GET_CLASSIFICATIONS_BY_BRAND: (brand) =>
    `/suiteql/classification/search-by-brand?brand=${brand}`,
  GET_ALL_PRODUCTS: ({
    limit,
    offset,
    sort,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/all-products?${params.toString()}`;
  },
  GET_SUB_CATEGORIES_BY_PARENT: (id) =>
    `/suiteql/commerceCategory/sub-category-by-parent/${id}`,
  GET_PRODUCT_BY_ID: (id) => `/suiteql/item/by-id?id=${id}`,
  POST_GET_PRODUCT_BY_PARENT: () => `/suiteql/item/by-parent`,
  POST_GET_PRODUCTS_BY_GROUP: () => `/suiteql/item/by-product-group`,
  POST_GET_ITEM_BY_IDS: ({
    limit,
    offset,
    sort,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  } = {}) => {
    const params = new URLSearchParams();
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/by-ids?${params.toString()}`;
  },
  POST_CHECK_ITEM_IDS: () => `/suiteql/item/check-ids`,
  GET_ITEMS_BY_CLASS: ({
    classId,
    limit,
    offset,
    sort,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (classId) params.append("classId", classId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/by-class?${params.toString()}`;
  },
  GET_ITEMS_BY_BRAND: ({
    brand,
    limit,
    offset,
    sort,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (brand) params.append("brand", brand);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/by-brand?${params.toString()}`;
  },
  GET_ITEMS_BY_CLASS_AND_BRAND: ({
    classId,
    brand,
    limit,
    offset,
    sort,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (classId) params.append("classId", classId);
    if (brand) params.append("brand", brand);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/by-class-and-brand?${params.toString()}`;
  },
  GET_ITEMS_BY_CATEGORY: ({
    category,
    limit,
    offset,
    sort,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (category) params.append("category", category);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/by-category?${params.toString()}`;
  },
  GET_CUSTOMER_BY_EMAIL: (email) =>
    `/suiteql/customer/by-email?email=${encodeURIComponent(email)}`,
  // The caller's own address book (all lines); the customer comes from the token.
  GET_MY_ADDRESSES: () => `/suiteql/customer/addresses`,
  GET_COUNT_BY_CLASS: ({
    classId,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (classId) params.append("classId", classId);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/count-by-class?${params.toString()}`;
  },
  GET_COUNT_BY_BRAND: ({
    brand,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (brand) params.append("brand", brand);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/count-by-brand?${params.toString()}`;
  },
  POST_GET_COUNT_BY_NAME: ({
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/count-by-name?${params.toString()}`;
  },
  GET_COUNT_BY_CATEGORY: ({
    category,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (category) params.append("category", category);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/count-by-category?${params.toString()}`;
  },
  GET_COUNT_ALL_PRODUCTS: ({
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/count-all-products?${params.toString()}`;
  },
  GET_ORDER_AGAIN: ({ userId, limit, offset }) => {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    return `/suiteql/order-again?${params.toString()}`;
  },
  GET_ITEMS_ORDER_HISTORY_BY_USER: ({
    userId,
    limit,
    offset,
    sort,
    searchByName,
  }) => {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (searchByName) params.append("searchByName", searchByName);
    return `/suiteql/transaction/by-user-order-history?${params.toString()}`;
  },
  GET_COUNT_USER_ORDER_HISTORY: ({ userId, searchByName }) => {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (searchByName) params.append("searchByName", searchByName);
    return `/suiteql/transaction/count-user-order-history?${params.toString()}`;
  },
  GET_TRANSACTION_BY_ID: ({ userId, limit, offset, sort, month, type }) => {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (month) params.append("month", month);
    // Narrows to one NetSuite transaction type ("SalesOrd", …) server-side,
    // so `limit` counts that type rather than rows of every type.
    if (type) params.append("type", type);
    return `/suiteql/transaction/by-userId?${params.toString()}`;
  },
  GET_RETURN_REQUESTS: ({ userId, limit, offset }) => {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    return `/suiteql/returnRequest/by-userId?${params.toString()}`;
  },
  GET_RETURN_REASONS: () => `/suiteql/returnRequest/reasons`,
  GET_RETURN_DETAIL: ({ userId, tranid }) => {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (tranid) params.append("tranid", tranid);
    return `/suiteql/returnRequest/by-tranid?${params.toString()}`;
  },
  GET_ORDER_DETAILS_BY_TRANSACTION: ({
    transactionId,
    userId,
    limit,
    offset,
  }) => {
    const params = new URLSearchParams();
    if (transactionId) params.append("transactionId", transactionId);
    if (userId) params.append("userId", userId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    return `/suiteql/transaction/order-details-by-transaction?${params.toString()}`;
  },
  // Every invoice of the caller's own customer, newest first, each with its
  // originating Sales Order and "Shipment i of n" (Invoices & statements page).
  GET_INVOICES_BY_USER_ID: ({ userId, limit, offset }) => {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    return `/suiteql/transaction/invoices-by-userId?${params.toString()}`;
  },
  GET_INVOICES_BY_TRANSACTION: ({ transactionId, userId }) => {
    const params = new URLSearchParams();
    if (transactionId) params.append("transactionId", transactionId);
    if (userId) params.append("userId", userId);
    return `/suiteql/transaction/invoices-by-transaction?${params.toString()}`;
  },
  // GET_TRANSACTION_BY_EMAIL: ({ email, limit, offset }) => {
  //     const params = new URLSearchParams();
  //     if (email) params.append('email', email);
  //     if (limit) params.append('limit', limit);
  //     if (offset) params.append('offset', offset);
  //     return `/suiteql/transaction/by-email?${params.toString()}`;
  // },

  // Message/PDF Download Endpoints
  // The emailed document, streamed through our backend — the credit memo
  // download on ReturnDetails. Invoices use GET_INVOICE_PDF instead.
  GET_TRANSACTION_DOCUMENT: (transactionId) =>
    `/suiteql/message/${transactionId}/document`,
  // The invoice as a PDF, rendered by our backend from live NetSuite data so
  // every invoice is downloadable (NetSuite kept an emailed copy for only
  // about half of them). `userId` is the transaction router's ownership
  // check, like every other /suiteql/transaction call.
  GET_INVOICE_PDF: ({ invoiceId, userId }) => {
    const params = new URLSearchParams();
    if (invoiceId) params.append("invoiceId", invoiceId);
    if (userId) params.append("userId", userId);
    return `/suiteql/transaction/invoice-pdf?${params.toString()}`;
  },

  POST_GET_ITEMS_BY_NAME: ({
    limit,
    offset,
    sort,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/item/search-by-name-like?${params.toString()}`;
  },
  GET_SHIPPING_METHOD: (id) => `/suiteql/shipItem/${id}`,
  POST_CHECK_INVENTORY: () => "/suiteql/inventory/check-inventory",
  // GET_ACTIVE_PROMOTIONS: () => "/suiteql/promotion",
  GET_TOP_SALE: ({ limit, fromDate }) => {
    const params = new URLSearchParams();
    if (limit) params.append("limit", limit);
    if (fromDate) params.append("fromDate", fromDate);
    return `/suiteql/saleInvoiced/top-sale-details?${params.toString()}`;
  },
  GET_PROMOTIONS_BY_PRODUCT: ({ productId, limit, offset }) => {
    const params = new URLSearchParams();
    if (productId) params.append("productId", productId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    return `/suiteql/promotion/by-product?${params.toString()}`;
  },
  GET_PRODUCTS_WITH_ACTIVE_PROMOTIONS: ({
    limit,
    offset,
    sort,
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  }) => {
    const params = new URLSearchParams();
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    if (sort) params.append("sort", sort);
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/promotion/products-with-promotions?${params.toString()}`;
  },
  GET_UNIQUE_PROMOTION_BRANDS: ({ searchByName } = {}) => {
    const params = new URLSearchParams();
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    return `/suiteql/promotion/unique-brands?${params.toString()}`;
  },
  GET_UNIQUE_PROMOTION_MANUFACTURERS: ({ searchByName } = {}) => {
    const params = new URLSearchParams();
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    return `/suiteql/promotion/unique-manufacturers?${params.toString()}`;
  },
  GET_COUNT_PRODUCTS_WITH_ACTIVE_PROMOTIONS: ({
    minPrice,
    maxPrice,
    searchByName,
    selectedCategories,
    selectedBrands,
    selectedManufacturers,
  } = {}) => {
    const params = new URLSearchParams();
    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);
    if (searchByName)
      params.append("searchByName", encodeURIComponent(searchByName));
    if (selectedCategories)
      params.append("selectedCategories", selectedCategories);
    if (selectedBrands) params.append("selectedBrands", selectedBrands);
    if (selectedManufacturers)
      params.append("selectedManufacturers", selectedManufacturers);
    return `/suiteql/promotion/products-with-promotions/count?${params.toString()}`;
  },

  // Tax Endpoints
  GET_TAX_RATES: ({ country, province, city }) => {
    const params = new URLSearchParams();
    if (country) params.append("country", country);
    if (province) params.append("province", province);
    if (city) params.append("city", city);
    return `/suiteql/tax/rates?${params.toString()}`;
  },
  POST_CALCULATE_TAX: () => "/suiteql/tax/calculate",
  // GET_TAX_RATES_BY_POSTAL_CODE: (country, postalCode) => `/suiteql/tax/rates/${country}/${postalCode}`,

  // Recurring Order Endpoints (SuiteQL)
  GET_RECURRING_ORDERS_BY_CUSTOMER: ({ customerId, limit, offset }) => {
    const params = new URLSearchParams();
    if (customerId) params.append("customerId", customerId);
    if (limit) params.append("limit", limit);
    if (offset) params.append("offset", offset);
    return `/suiteql/recurring-order?${params.toString()}`;
  },
  GET_RECURRING_ORDER_BY_ID: (id) => `/suiteql/recurring-order/${id}`,

  // NETSUITE REST API Endpoints
  GET_CUSTOMER: (id) => `/restapi/customer/${id}`,
  GET_SALES_ORDER: (id) => `/restapi/salesOrder/${id}`,
  POST_SALES_ORDER: () => `/restapi/salesOrder`,
  PATCH_UPDATE_CUSTOMER: () => `/restapi/customer/me`,
  POST_CREATE_CUSTOMER: () => `/restapi/customer`,
  POST_RECURRING_ORDER: () => `/restapi/customrecord_recurring_order`,
  UPDATE_RECURRING_ORDER: (id) => `/restapi/customrecord_recurring_order/${id}`,

  // Returns (RMA) Endpoints
  POST_RETURN_REQUEST: () => `/restapi/returnAuthorization`,
  // Creates the Purolator shipment and books the pickup — see backend return.service.js#bookPickup.
  POST_RETURN_PICKUP: (id) => `/restapi/returnAuthorization/${id}/pickup`,
  GET_RETURN_LABEL: (id) => `/restapi/returnAuthorization/${id}/label`,
  // Purolator's pickup cutoff for the return's address — the page saves it per postal code.
  GET_RETURN_PICKUP_WINDOW: (id) =>
    `/restapi/returnAuthorization/${id}/pickup-window`,
  // Photos ride as base64 JSON, not multipart — the backend has no upload
  // middleware. The caps (5 photos, 7MB each) are sized so the base64 body,
  // ~47MB at most, fits `express.json({ limit: "50mb" })`.
  POST_RETURN_PHOTOS: (id) => `/restapi/returnAuthorization/${id}/photos`,

  // Cart Item Endpoints
  POST_CART_ITEM: () => `/restapi/customrecord_cart_item`,
  GET_CART_ITEMS_BY_CUSTOMER: (customerId) => `/suiteql/cartItem/${customerId}`,
  POST_CREATE_CART_ITEM_AUDIT: () => `/restapi/customrecord_audit_cart_item`,
  GET_AUDIT_CART_ITEMS_BY_USER: (userId) => `/suiteql/auditCartItem/${userId}`,

  // Stripe Endpoints
  // Customer endpoints
  POST_CREATE_STRIPE_CUSTOMER: () => `/stripe/customer/create-stripe`,
  GET_STRIPE_CUSTOMER: (customerId) => `/stripe/customer/${customerId}`,
  GET_STRIPE_CUSTOMER_BY_EMAIL: (email) =>
    `/stripe/customer/email/${encodeURIComponent(email)}`,
  PUT_UPDATE_STRIPE_CUSTOMER: (customerId) => `/stripe/customer/${customerId}`,

  // Payment method endpoints
  POST_ATTACH_PAYMENT_METHOD: (customerId) =>
    `/stripe/customer/${customerId}/payment-methods/attach`,
  GET_PAYMENT_METHODS: (customerId) =>
    `/stripe/customer/${customerId}/payment-methods`,
  DELETE_PAYMENT_METHOD: (paymentMethodId) =>
    `/stripe/payment-methods/${paymentMethodId}`,

  // Payment endpoints
  POST_CREATE_PAYMENT: () => `/stripe/payment/create`,
  POST_CONFIRM_PAYMENT: () => `/stripe/payment/confirm`,
  POST_PROCESS_PAYMENT: () => `/stripe/payment/process`,
  POST_CAPTURE_PAYMENT: () => `/stripe/payment/capture`,
  // Pay an open NetSuite invoice by card (records a customerPayment)
  POST_PAY_INVOICE: () => `/stripe/invoice/pay`,
  POST_PAY_INVOICE_CAPTURE: () => `/stripe/invoice/pay/capture`,

  // Postal Code Lookup Endpoints
  GET_POSTAL_LOOKUP: (country, code) => `/postal-lookup/${country}/${code}`,

  // Purolator Tracking Endpoints
  GET_PUROLATOR_TRACKING: (pin) => `/purolator/tracking/${pin}`,
};

export default endpoint;
